import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'

Vue.use(Router)

// A partir do vue-router 3.1 a navegacao devolve uma Promise que e REJEITADA
// quando um guard redireciona ou cancela a rota. O @websanova/vue-auth (2019)
// nao trata essa rejeicao: ao entrar em "/" ja autenticado ele manda para
// "/app/", a Promise rejeita e a excecao interrompe o fluxo — o login nao
// conclui e o token nao chega a ser salvo.
// Redirecionar e cancelar sao resultados esperados aqui, entao engolimos
// apenas esses dois casos e deixamos os demais erros propagarem.
const ignoredNavigationErrors = [
  Router.NavigationFailureType && Router.NavigationFailureType.redirected,
  Router.NavigationFailureType && Router.NavigationFailureType.cancelled
].filter(type => type !== undefined)

const isIgnoredNavigationError = error => {
  if (!error) return false
  if (ignoredNavigationErrors.indexOf(error.type) > -1) return true

  // Versoes 3.1–3.3 nao expunham NavigationFailureType e so traziam a mensagem.
  return /Redirected when going from|Navigation cancelled/.test(error.message || '')
}

;['push', 'replace'].forEach(method => {
  const original = Router.prototype[method]

  Router.prototype[method] = function (location, onResolve, onReject) {
    if (onResolve || onReject) {
      return original.call(this, location, onResolve, onReject)
    }

    return original.call(this, location).catch(error => {
      if (isIgnoredNavigationError(error)) return error
      return Promise.reject(error)
    })
  }
})

export default new Router({
  mode: 'history',
  linkActiveClass: 'is-active',
  linkExactActiveClass: 'is-active',
  base: process.env.BASE_URL,
  routes
})
